import get from 'lodash/get';

import { filterCurrencyString } from '@/services/forms';

const buildingDeductibles = [
	'newBuilding.deductible',
	'newBuilding.cp1044.deductible',
	'newBuilding.cp1401.deductible',
];

export function getCommercialPropertyChanges( formGuid: string, formData: any ) {
	const embeddedForms = formData?.embeddedFormId || [];

	return embeddedForms.flatMap( ( locationForm: any, locationIndex: number ) => {
		const locationDeductible = get( locationForm, 'riskDeductible', null );
		let locationQuestion;

		if ( Number( filterCurrencyString( locationDeductible?.value ) ) < 1000 ) {
			locationQuestion = {
				parentForm: 'Commercial Property (C-2393)',
				formName: `Location Information ${ locationForm?.newLocation?.number }`,
				formGuid: formGuid,
				systemLabel: 'All Other Perils Deductible',
				systemId: 'riskDeductible',
				fullPath: `embeddedFormId[${ locationIndex }].riskDeductible`,
				subformPaths: [ `embeddedFormId[${ locationIndex }]` ],
				oldValue: locationDeductible.label,
				newValueDisplay: '$1,000',
				newValue: '1000'
			};
		}

		const buildings = get( locationForm, 'newLocation.tableEmbeddedFormBuildings', [] );
		const mappedBuildings = buildings.flatMap( ( building: any, buildingIndex: number ) => {
			return buildingDeductibles.map( deductible => {
				const value = get( building, deductible, null );

				if ( value && Number( filterCurrencyString( value?.value ) ) < 1000 ) {
					return {
						parentForm: 'Commercial Property (C-2393)',
						formName: `Building Information ${ building?.newBuilding?.description }`,
						formGuid: formGuid,
						systemLabel: 'All Other Perils Deductible',
						systemId: deductible,
						fullPath: `embeddedFormId[${ locationIndex }].newLocation.tableEmbeddedFormBuildings[${ buildingIndex }].${ deductible }`,
						subformPaths: [
							`embeddedFormId[${ locationIndex }]`,
							`embeddedFormId[${ locationIndex }].newLocation.tableEmbeddedFormBuildings[${ buildingIndex }]`
						],
						oldValue: value.label,
						newValueDisplay: '$1,000',
						newValue: '1000'
					};
				}
			});
		});

		return [ locationQuestion, ...mappedBuildings ];
	}).filter( ( a: any ) => a );
};
